import BodilyInjuryMap from './BodilyInjuryMap';
export default BodilyInjuryMap;
